import { alpha, Box } from '@mui/material';

import VectorTop1 from 'assets/vectors/vector-top-1.svg';
import Vector from 'assets/vectors/vector.svg';
import VectorTop2 from 'assets/vectors/vector-top-2.svg';
import VectorBottom1 from 'assets/vectors/vector-bottom-1.svg';
import VectorBottom2 from 'assets/vectors/vector-bottom-2.svg';

const AuthBanner = () => {
  return (
    <Box
      sx={{
        background: (theme) =>
          `linear-gradient(107deg, ${alpha(theme.palette.primary.main, 0.9)} 0.45%, ${alpha(
            theme.palette.primary.main,
            0.6,
          )} 99.55%)`,
        minWidth: '45%',
        borderTopRightRadius: '30px',
        borderBottomRightRadius: '30px',
        position: 'relative',
        overflow: 'hidden',
        display: { xs: 'none', md: 'block' },
      }}
    >
      <img src={VectorTop1} style={{ opacity: 0.15, position: 'absolute', width: 140 }} />
      <img src={VectorTop2} style={{ opacity: 0.15, position: 'absolute', width: 160 }} />
      <img src={Vector} style={{ position: 'absolute', width: 686, left: '-188px', transform: 'rotate(45deg)' }} />
      <img src={VectorBottom1} style={{ opacity: 0.15, position: 'absolute', width: 300, bottom: 0, right: 0 }} />
      <img src={VectorBottom2} style={{ opacity: 0.15, position: 'absolute', width: 320, bottom: 0, right: 0 }} />
    </Box>
  );
};

export default AuthBanner;
